import accountWatchList from './accountWatchList'
import billingRoutes from './billing'
import businessRoutes from './business'
import configurationsRoutes from './configurations'
import contextRoutes from './context'
import dashboardRoutes from './dashboard'
import notificationRoutes from './notifications'
import partnersRoutes from './partners'
import paymentsRoutes from './payments'
import profileRoutes from './profile'
import reportingRoutes from './reporting'
import supportRoutes from './support'
import transactionsRoutes from './transactions'
import userRoutes from './users'
import virtualTerminalRoutes from './virtualTerminal'

export default [
  {
    path: '/',
    name: 'root',
    component: {
      render () {
        return null
      },
      mounted () {
        this.$store.dispatch('unauthorize')
        this.$store.dispatch('clearAppliedContext')

        this.$router.push({ name: 'dashboard' })
      }
    },
    meta: {
      layout: 'simple',
      isPublic: true
    }
  },
  {
    path: '/user-invite',
    name: 'userInvite',
    component: () => import('@/components/UserInvite/UserInvite.vue'),
    meta: {
      layout: 'simple',
      isPublic: true
    },
    props: (route) => ({ inviteId: route.query.InviteId })
  },
  {
    path: '/sign-in',
    name: 'signIn',
    component: () => import('@/views/SignIn/SignIn.vue'),
    meta: {
      layout: 'simple',
      isPublic: true
    },
    props: (route) => ({ query: route.query })
  },
  {
    path: '/sign-out',
    name: 'signOut',
    component: () => import('@/views/SignOut/SignOut.vue'),
    meta: {
      layout: 'simple',
      isPublic: true
    }
  },
  {
    path: '/404',
    name: 'notFound',
    component: () => import('@/views/NotFound.vue'),
    meta: {
      layout: 'simple',
      isPublic: true
    }
  },
  {
    path: '*',
    redirect: { name: 'notFound' }
  },
  ...accountWatchList,
  ...billingRoutes,
  ...businessRoutes,
  ...configurationsRoutes,
  ...contextRoutes,
  ...dashboardRoutes,
  ...notificationRoutes,
  ...partnersRoutes,
  ...paymentsRoutes,
  ...profileRoutes,
  ...reportingRoutes,
  ...supportRoutes,
  ...transactionsRoutes,
  ...userRoutes,
  ...virtualTerminalRoutes
]
